/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigCheckbox
 */
export interface BidirectionalActionConfigCheckbox {
    /**
     * 
     * @type {string}
     * @memberof BidirectionalActionConfigCheckbox
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof BidirectionalActionConfigCheckbox
     */
    _default: boolean;
}

/**
 * Check if a given object implements the BidirectionalActionConfigCheckbox interface.
 */
export function instanceOfBidirectionalActionConfigCheckbox(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "_default" in value;

    return isInstance;
}

export function BidirectionalActionConfigCheckboxFromJSON(json: any): BidirectionalActionConfigCheckbox {
    return BidirectionalActionConfigCheckboxFromJSONTyped(json, false);
}

export function BidirectionalActionConfigCheckboxFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigCheckbox {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        '_default': json['default'],
    };
}

export function BidirectionalActionConfigCheckboxToJSON(value?: BidirectionalActionConfigCheckbox | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'default': value._default,
    };
}

